import { UserRole } from 'constants/common';
import { TFunction } from 'i18next';
import { SelectOption } from 'models/form/select';

export const buildUserRoleOptions = (t: TFunction): SelectOption[] =>
  Object.keys(UserRole).map(role => ({
    label: t(`pages.users.roles.${role.toLocaleLowerCase()}`),
    value: role
  }));
